
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[code]",
      function () {
        return require("private-next-pages/help/[code].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/[code]"])
      });
    }
  